import { render } from "./vue-bootstrap-modal.vue?vue&type=template&id=045bf8a4"
import script from "./vue-bootstrap-modal.vue?vue&type=script&lang=js"
export * from "./vue-bootstrap-modal.vue?vue&type=script&lang=js"

import "./vue-bootstrap-modal.vue?vue&type=style&index=0&id=045bf8a4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__